import React, { useCallback, useState } from "react";

import "./NotesList.styles.scss";
import { DeleteConfirmModal } from "../../modals/Notes-delete/NotesDelete";
import { NotesItem } from "../Notes-item/NotesItem";
import { useDealActions } from "store";
import { INote } from "store/types";

interface NotesListProps {
  list: INote[];
  onClickEditNote: (note: INote) => void;
}

export const NotesList: React.FC<NotesListProps> = ({ list, onClickEditNote }) => {
  const [showModal, setShowModal] = useState<number>(0);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
  const { deleteNoteAction } = useDealActions();

  const deleteNote = useCallback(async (noteId: number): Promise<void> => {
    try {
      setDeleteLoading(true);
      await deleteNoteAction(noteId);
    } finally {
      setDeleteLoading(false);
    }
  }, []);

  return (
    <div className="notes-list">
      {list.map((note: INote) => (
        <NotesItem
          onClickDelete={() => setShowModal(note.id)}
          onClickEditNote={() => onClickEditNote(note)}
          note={note}
          key={note.id}
        />
      ))}
      <DeleteConfirmModal
        isOpen={showModal}
        onConfirm={deleteNote}
        onRequestClose={() => setShowModal(0)}
        loading={deleteLoading}
      />
    </div>
  );
};
